// plays.js
export default {
  playsGoal: [
    [124234234, 53000, 2002, '054:00.001', 12000, 2, 1, 4, 1, 2, 1, 0.412, 0.085],
    [124234235, 53010, 16226, '025:00.001', 59800, 2, 1, 2, 2, 1, 1, 0.381, 0.07],
    [124234236, 53000, 18010, '038:00.001', 53800, 2, 1, 3, 3, 2, 1, 0.12, 0.16],
    [124234237, 53010, 39038, '044:00.001', 60000, 2, 1, 3, 1, 1, 1, 0.4, 0.12],
    [124234238, 53000, 11760, '088:00.001', 12000, 2, 1, 6, 2, 2, 1, 0.52, 0.01],
    [124234239, 53010, 18870, '012:00.001', 59800, 2, 1, 1, 3, 1, 1, 0.52, 0.15],
    [124234240, 53000, 27695, '028:00.001', 53800, 2, 1, 2, 1, 2, 1, 0.55, 0.21],
    [124234255, 53010, 2002, '057:00.001', 60000, 2, 1, 4, 2, 1, 1, 0.83, 0.13],
    [124234234, 53000, 11556, '054:00.001', 12000, 3, 1, 4, 1, 2, 1, 0.512, 0.075],
    [124234235, 53010, 16226, '025:00.001', 59800, 3, 1, 2, 2, 1, 1, 0.381, 0.07],
    [124234236, 53000, 2002, '038:00.001', 53800, 3, 1, 3, 3, 2, 1, 0.12, 0.16],
    [124234237, 53010, 39038, '044:00.001', 60000, 3, 1, 3, 1, 1, 1, 0.4, 0.12],
    [124234238, 53000, 11760, '088:00.001', 12000, 3, 1, 6, 2, 2, 1, 0.52, 0.01],
    [124234239, 53010, 2002, '012:00.001', 59800, 3, 1, 1, 3, 1, 1, 0.52, 0.15],
    [124234240, 53000, 27695, '028:00.001', 53800, 3, 1, 2, 1, 2, 1, 0.55, 0.21],
    [124234255, 53010, 344, '057:00.001', 60000, 3, 1, 4, 2, 1, 1, 0.83, 0.13],
  ],
  plays: [
    [
      22147985, // play_id
      53010, // game_id
      27164, // player_id
      '061:15.865', // moment_of_play
      12, // category_id
      2, // category_type
      2, // matchlapse
      4, // section
      1, // match_result
      2, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.5393, // x1
      0.7039, // y1
      0.5813, // x2
      0.8112, // y2
      0.4645, // x3
      0.9573, // y3
    ],
    [
      22148143, // play_id
      53010, // game_id
      16155, // player_id
      '061:15.865', // moment_of_play
      12, // category_id
      2, // category_type
      2, // matchlapse
      6, // section
      1, // match_result
      2, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.2597, // x1
      0.2854, // y1
      0.3201, // x2
      0.1908, // y2
      0.3411, // x3
      0.1615, // y3
    ],
    [
      22148451, // play_id
      53010, // game_id
      2002, // player_id
      '092:30.708', // moment_of_play
      547, // category_id
      2, // category_type
      2, // matchlapse
      5, // section
      1, // match_result
      2, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.2283, // x1
      0.2195, // y1
      0.3149, // x2
      0.202, // y2
      0.4986, // x3
      0.0439, // y3
    ],
    [
      22146832, // play_id
      53010, // game_id
      2002, // player_id
      '031:50.331', // moment_of_play
      208, // category_id
      2, // category_type
      1, // matchlapse
      3, // section
      1, // match_result
      2, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.9239, // x1
      0.8715, // y1
      0.9239, // x2
      0.8715, // y2
      0.9225, // x3
      0.8834, // y3
    ],
    [
      21144941, // play_id
      53000, // game_id
      427, // player_id
      '047:39.957', // moment_of_play
      12, // category_id
      2, // category_type
      1, // matchlapse
      3, // section
      2, // match_result
      1, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.4855, // x1
      0.8659, // y1
      0.4855, // x2
      0.8659, // y2
      0.5275, // x3
      0.9557, // y3
    ],
    [
      21144995, // play_id
      53000, // game_id
      427, // player_id
      '047:39.957', // moment_of_play
      547, // category_id
      2, // category_type
      1, // matchlapse
      3, // section
      2, // match_result
      1, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.4855, // x1
      0.8659, // y1
      0.4855, // x2
      0.8659, // y2
      0.5275, // x3
      0.9557, // y3
    ],
    [
      22147985, // play_id
      53010, // game_id
      2002, // player_id
      '061:15.865', // moment_of_play
      12, // category_id
      3, // category_type
      2, // matchlapse
      4, // section
      1, // match_result
      1, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.5393, // x1
      0.7039, // y1
      0.5813, // x2
      0.8112, // y2
      0.4645, // x3
      0.9573, // y3
    ],
    [
      22148143, // play_id
      53010, // game_id
      16155, // player_id
      '061:15.865', // moment_of_play
      12, // category_id
      3, // category_type
      2, // matchlapse
      6, // section
      1, // match_result
      1, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.2597, // x1
      0.2854, // y1
      0.3201, // x2
      0.1908, // y2
      0.3411, // x3
      0.1615, // y3
    ],
    [
      22148451, // play_id
      53010, // game_id
      27164, // player_id
      '092:30.708', // moment_of_play
      547, // category_id
      3, // category_type
      2, // matchlapse
      5, // section
      1, // match_result
      1, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.2283, // x1
      0.2195, // y1
      0.3149, // x2
      0.202, // y2
      0.4986, // x3
      0.0439, // y3
    ],
    [
      22146832, // play_id
      53010, // game_id
      2002, // player_id
      '031:50.331', // moment_of_play
      547, // category_id
      3, // category_type
      1, // matchlapse
      3, // section
      1, // match_result
      1, // playing_as
      1, // total
      1, // total_games
      10, // table_position
      0.9239, // x1
      0.8715, // y1
      0.9239, // x2
      0.8715, // y2
      0.9225, // x3
      0.8834, // y3
    ],
  ],
};
